import React from "react";
import { ExternalLink } from "lucide-react";
import { resolveTenantSlug } from "../../lib/api";

/**
 * Admin "View Storefront" — opens the public storefront for the admin's
 * tenant in a new tab so they can preview customer-facing changes without
 * logging out. Resolves the active tenant slug from the request the same
 * way the axios interceptor does (localStorage > path > default).
 */
export default function ViewStorefrontButton() {
  const slug = resolveTenantSlug();
  // The default tenant's storefront lives at `/`; every other tenant lives
  // at `/t/<slug>/` so the host-based + path-based resolvers agree.
  const href = !slug || slug === "default" ? "/" : `/t/${slug}/`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium uppercase tracking-wider bg-[hsl(var(--kb-surface-alt))] hover:bg-[hsl(var(--kb-border))] text-[hsl(var(--kb-text))] border border-[hsl(var(--kb-border))] rounded-sm transition-colors"
      data-testid="view-storefront-btn"
      title="Open your storefront in a new tab"
    >
      <ExternalLink size={13} />
      View Storefront
    </a>
  );
}
